<template>
  <div>
    <slot v-if="this.visible"></slot>
  </div>
</template>

<script>
export default {
  name: "StoreFacet_Item",
  data() {
    return {
      visible: true
    };
  }
};
</script>
